<template>
  <div
    :data-tst="`repchart_column_${item.id}`"
    class="repchart_column"
    :class="{
      repchart_column_active: item.id === reportItemId,
    }"
    @mouseenter="
      () => {
        if (item.isEmpty) return
        if (!reportItemId) {
          $store.commit('reports_set', { key: 'reportItem', value: item })
        }
      }
    "
    @click="
      () => {
        if (item.isEmpty) return
        $store.commit('reports_set', { key: 'reportItem', value: item })
        $store.commit('reports_set', {
          key: 'reportItem_id',
          value: item.id === reportItemId ? null : item.id,
        })
      }
    "
  >
    <div
      v-if="viewProps.colValue.key === 'strategy'"
      class="repchart_column_chart repchart_column_chart_oop"
    >
      <div
        class="repchart_column_chart_inner"
        :style="useHex ? item.backgrounds.hex : item.backgrounds.var"
      ></div>
    </div>
    <div
      v-if="viewProps.display_oop"
      class="repchart_column_chart repchart_column_chart_oop"
    >
      <div
        class="repchart_column_chart_inner"
        :style="item.oop[`${viewProps.colValue.key}_style`]"
      ></div>
    </div>
    <div
      v-if="viewProps.display_ip"
      class="repchart_column_chart repchart_column_chart_ip"
    >
      <div
        class="repchart_column_chart_inner"
        :style="item.ip[`${viewProps.colValue.key}_style`]"
      ></div>
    </div>

    <div class="repchart_column_legend repchart_column_chart_center">
      <slot
        name="col_name"
        :item="item"
      ></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RepChartColumn',
  props: {
    item: Object,
    reportItemId: String,
    viewProps: Object,
    useHex: Boolean,
    legendVertical: Boolean,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss">
.repchart_chart {
  .vue-recycle-scroller__item-view {
    max-width: var(--col-width);
  }
}
</style>

<style lang="scss" scoped>
.repchart {
  // --col-width: 23px;
  // --nav-height: 5.5rem;
  // --legend-height: 5rem;
  // flex: 1;
  // display: flex;
  // flex-direction: column;
  // min-height: 0;
  // min-width: 0;
  &_column {
    z-index: 1;
    flex-shrink: 0;
    position: relative;
    height: 100%;
    width: 100%;
    // width: var(--col-width);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    // margin-right: 10px;
    cursor: pointer;
    &_chart {
      // margin: 0.5px;
      display: flex;
      flex: 1;
      &_inner {
        border-radius: 4px;
        width: 100%;
        position: relative;
        overflow: hidden;
        // background-image: var(--background-image);
        // background-size: var(--background-size);
        // &::before {
        //   content: '';
        //   position: absolute;
        //   left: 0;
        //   top: 0;
        //   height: 100%;
        //   // width: calc(100% - 1px);
        //   width: 100%;
        //   border-radius: 4px;
        //   // rotate: 180deg;
        // }
        // transform: rotate(180deg);
        // outline: solid var(--clr-black-1-3) 1px;
      }
      &_oop {
        order: 1;
        align-items: flex-end;
      }
      &_ip {
        order: 1;
        align-items: flex-end;
      }
      &_center {
        order: 2;
        align-items: flex-end;
      }
    }
    &_legend {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      line-height: 1.3;
      text-align: center;
      position: relative;
      z-index: 2;
      height: var(--legend-height);
      // font-weight: 500;
      font-weight: 600;
    }
    &:hover {
      z-index: 4;
      .repchart_column_inner {
        opacity: 0.75;
      }
      .repchart_column_legend {
        background: rgba(255, 255, 255, 0.075);
        border-radius: 4px;
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        border-radius: 4px;
        z-index: 1;
        background: rgba(255, 255, 255, 0.15);
      }
    }
    &_active {
      .repchart_column_legend {
        background: rgba(255, 255, 255, 0.075);
        border-radius: 4px;
      }
      &:before {
        content: '';
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        border-radius: 4px;
        z-index: 1;
        background: rgba(255, 255, 255, 0.15);
        // border: solid var(--clr-primary) 2px;
      }
    }
    &_split {
      .repchart_chart_players {
        justify-content: center;
      }
      .repchart_column_chart_oop {
        order: 1;
      }
      .repchart_column_chart_ip {
        align-items: flex-start;
        order: 3;
      }
      .repchart_column_chart_center {
        order: 2;
      }
    }
  }
}
// &_chart {
//   &_flipped {
//     .repchart_chart_players {
//       justify-content: flex-start;
//       flex-direction: column-reverse;
//     }
//   }
</style>
